import { takeLatest, select } from 'redux-saga/effects'
import TagManager from '@sooro-io/react-gtm-module'

import get from 'lodash/get'

import { GA, LIST_MODE } from 'Config/app'

import {
  LOAD_CLIENT_DETAILS,
  LOAD_MERCHANT,
  LOAD_SERVICE,
} from 'Store/Actions/marketplace'

import { getGtmId, getConfig } from 'Store/Selectors/app'

function* watchLoadGtm({ data, type }) {
  const gtmId = get(data, 'google_tag_manager_id')
  const clientGtmId = yield select(getGtmId)

  // prevents duplicates when Client GTM is the only one available
  if (gtmId && gtmId === clientGtmId && type !== LOAD_CLIENT_DETAILS.SUCCESS) {
    return
  }

  // Load client GTM if present (but not same as env value)
  if (gtmId && gtmId !== GA.KEY) {
    TagManager.initialize({ gtmId })
  }
}

export default function* analytics() {
  // gaId comes from subdomain config (normally Nabooki GTM)
  const config = yield select(getConfig)
  const gaId = get(config, 'gaId')
  const listMode = LIST_MODE || get(config, 'listMode')

  if (gaId && !listMode) {
    TagManager.initialize({ gtmId: gaId })
  }

  // gtmId comes from client details
  const gtmId = yield select(getGtmId)

  // (SSR) Load client GTM if present (but not same as gaId in subdomain config)
  if (gtmId && gtmId !== gaId) {
    TagManager.initialize({ gtmId })
  } else {
    // If not SSR then wait for client details to load to give us access to google_tag_manager_id
    yield takeLatest(LOAD_CLIENT_DETAILS.SUCCESS, watchLoadGtm)
  }

  if (listMode) {
    const state = yield select()

    const initializeGtmIfValid = id => {
      if (id && id !== gaId && id !== gtmId) {
        TagManager.initialize({ gtmId: id })
        return true
      }
      return false
    }

    // Check merchant/service GTM from store (loaded during SSR)
    const merchantGtmId = get(
      state,
      'marketplace.merchant.google_tag_manager_id',
    )
    const serviceGtmId = get(state, 'marketplace.service.google_tag_manager_id')

    const hasMerchantGtm = initializeGtmIfValid(merchantGtmId)
    const hasServiceGtm = initializeGtmIfValid(serviceGtmId)
    const hasClientGtm = gtmId && gtmId !== gaId

    if (gaId && !hasMerchantGtm && !hasServiceGtm && !hasClientGtm) {
      TagManager.initialize({ gtmId: gaId })
    }

    yield takeLatest(LOAD_MERCHANT.SUCCESS, watchLoadGtm)
    yield takeLatest(LOAD_SERVICE.SUCCESS, watchLoadGtm)
  }
}
